<ng-container *ngIf="additionalOperationsAction$ | async"></ng-container>

<div id="estimate-wrapper" class="w-full h-full flex flex-col items-stretch" fusePerfectScrollbar>
  <div class="p-4 pb-2 prices flex flex-row space-x-6 items-center">
    <ng-container
      *ngIf="estimate?.DiscountOrder > 0 || hasMaterialsDiscount || hasOperationsDiscount; else withoutDiscount">
      <div *ngIf="showItemsPriceBeforeVerified || confirmedOrder" class="flex flex-row items-center">
        <div class="label text-right" i18n>Стоимость заказа без скидки</div>

        <div class="value">
          {{ estimate?.PriceOrder + getProductsTotalPrice(products) | formatNumber : 2 | formatCurrency }}
        </div>
      </div>

      <div *ngIf="showItemsPriceBeforeVerified || confirmedOrder" class="flex flex-row items-center">
        <div i18n class="label text-right">Скидка</div>
        <div class="value">
          {{
            estimate?.DiscountOrder + estimate?.DiscountMaterial + estimate?.DiscountOperation || 0
              | formatNumber : 2
              | formatCurrency
          }}
        </div>
      </div>

      <div *ngIf="showItemsPriceBeforeVerified || confirmedOrder" class="flex flex-row items-center">
        <div i18n class="label text-right">Итого</div>
        <div class="value">
          <ng-container *ngIf="vatIncludeInPrice; else simpleVAT">
            <span
              >{{ estimate?.PriceOrderWithDiscount | formatNumber : 2 | formatCurrency }}
              <span i18n *ngIf="showTax" class="value"
                >в т.ч. НДС ({{ vatPercent }}%) - {{ estimate?.OrderVAT | formatNumber : 2 | formatCurrency }}</span
              ></span
            >
          </ng-container>
          <ng-template #simpleVAT
            ><span *ngIf="vatPercent > 0; else withoutVAT"
              >{{ estimate?.PriceOrderWithDiscount + estimate?.OrderVAT || 0 | formatNumber : 2 | formatCurrency }}
              <span i18n *ngIf="showTax" class="value"
                >НДС ({{ vatPercent }}%) - {{ estimate?.OrderVAT | formatNumber : 2 | formatCurrency }}</span
              ></span
            >
            <ng-template #withoutVAT
              >{{ estimate?.PriceOrderWithDiscount || 0 | formatNumber : 2 | formatCurrency }}
              <span i18n *ngIf="showTax" class="value">без НДС</span></ng-template
            >
          </ng-template>
        </div>
      </div>
    </ng-container>

    <ng-template #withoutDiscount>
      <div class="flex flex-row items-center">
        <div class="label text-right">
          <span i18n *ngIf="confirmedOrder">Стоимость заказа</span>
          <span i18n *ngIf="!confirmedOrder && showItemsPriceBeforeVerified">Ориентировочная стоимость заказа</span>
        </div>
        <div class="value">
          <ng-container *ngIf="vatIncludeInPrice; else simpleVAT">
            <span
              >{{ estimate?.PriceOrder + getProductsTotalPrice(products) | formatNumber : 2 | formatCurrency }}
              <span i18n *ngIf="showTax" class="value"
                >в т.ч. НДС ({{ vatPercent }}%) - {{ estimate?.OrderVAT | formatNumber : 2 | formatCurrency }}</span
              ></span
            >
          </ng-container>
          <ng-template #simpleVAT
            ><span *ngIf="vatPercent > 0; else withoutVAT"
              >{{
                estimate?.PriceOrder + getProductsTotalPrice(products) + estimate?.OrderVAT || 0
                  | formatNumber : 2
                  | formatCurrency
              }}
              <span i18n *ngIf="showTax" class="value"
                >НДС ({{ vatPercent }}%) - {{ estimate?.OrderVAT | formatNumber : 2 | formatCurrency }}</span
              ></span
            >
            <ng-template #withoutVAT
              >{{ estimate?.PriceOrder + getProductsTotalPrice(products) || 0 | formatNumber : 2 | formatCurrency }}
              <span i18n *ngIf="showTax" class="value">без НДС</span></ng-template
            >
          </ng-template>
        </div>
      </div>
    </ng-template>

    <mat-icon
      i18n-matTooltip
      class="mat-warn"
      *ngIf="!confirmedOrder"
      matTooltip="Конечная стоимость раскроя будет указана после проверки администратором"
      >warning
    </mat-icon>
  </div>

  <div fusePerfectScrollbar class="p-4 pt-2 flex flex-row flex-wrap gap-4 items-stretch">
    <ng-container *ngIf="!showOnlyMainWork; else showOnlyMainWorkBlock">
      <div class="mat-elevation-z2 flex-1">
        <mat-toolbar *ngIf="!singleEstimateList">
          <span i18n>Материалы</span>
        </mat-toolbar>
        <mat-divider></mat-divider>
        <table class="simple" fusePerfectScrollbar>
          <thead>
            <ng-container
              *ngTemplateOutlet="
                headerTemplate;
                context: {
                  hasDiscount: hasMaterialsDiscount || (hasOperationsDiscount && singleEstimateList),
                  hasAdditionalOperations: singleEstimateList && hasAddedAdditionalOperations
                }
              ">
            </ng-container>
          </thead>
          <tbody>
            <ng-container
              [ngTemplateOutlet]="bodyRowTemplate"
              [ngTemplateOutletContext]="{
                name: getMaterialName(item.Name, item.Article),
                count: item.Count,
                measure: item.Measure,
                cost: item.Price,
                discount: item.Discount,
                discountPct: item.DiscountPct,
                hasDiscount: hasMaterialsDiscount || (hasOperationsDiscount && singleEstimateList)
              }"
              *ngFor="let item of estimate?.Materials">
            </ng-container>

            <!-- products -->
            <ng-container
              [ngTemplateOutlet]="bodyRowTemplate"
              [ngTemplateOutletContext]="{
                name: item.name,
                count: item.count,
                measure: productMeasure,
                cost: item.price * item.count,
                discount: 0,
                discountPct: 0,
                hasDiscount: hasMaterialsDiscount || (hasOperationsDiscount && singleEstimateList)
              }"
              *ngFor="let item of products">
            </ng-container>

            <ng-container *ngIf="singleEstimateList">
              <ng-container
                [ngTemplateOutlet]="bodyRowTemplate"
                [ngTemplateOutletContext]="{
                  name: getMaterialName(item.Name, item.Article),
                  count: item.Count,
                  measure: item.Measure,
                  cost: item.Price,
                  discount: item.Discount,
                  discountPct: item.DiscountPct,
                  hasDiscount: hasMaterialsDiscount || hasOperationsDiscount,
                  additionalOperationTmpl:
                    item.AdditionalGUID && isCuttingCompleted ? removeAdditionalOperationTmpl : null,
                  additionalOperation: item
                }"
                *ngFor="let item of estimate?.Operations">
              </ng-container>
            </ng-container>
          </tbody>

          <tfoot *ngIf="!singleEstimateList && (confirmedOrder || showItemsPriceBeforeVerified)">
            <tr>
              <td i18n colspan="4">Итого</td>
              <td *ngIf="hasMaterialsDiscount">
                {{ estimate?.DiscountMaterial || 0 | formatNumber : 2 }}
              </td>
              <td>
                {{
                  estimate?.PriceMaterial - estimate?.DiscountMaterial + getProductsTotalPrice(products) || 0
                    | formatNumber : 2
                }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="mat-elevation-z2 flex-1" *ngIf="!singleEstimateList">
        <mat-toolbar>
          <span i18n>Работы</span>
        </mat-toolbar>
        <mat-divider></mat-divider>
        <table class="simple" fusePerfectScrollbar>
          <thead>
            <ng-container
              *ngTemplateOutlet="
                headerTemplate;
                context: {
                  hasDiscount: hasOperationsDiscount,
                  hasAdditionalOperations: hasAddedAdditionalOperations
                }
              ">
            </ng-container>
          </thead>
          <tbody>
            <ng-container
              [ngTemplateOutlet]="bodyRowTemplate"
              [ngTemplateOutletContext]="{
                name: getMaterialName(item.Name, item.Article),
                count: item.Count,
                measure: item.Measure,
                cost: item.Price,
                discount: item.Discount,
                discountPct: item.DiscountPct,
                hasDiscount: hasOperationsDiscount,
                additionalOperationTmpl:
                  item.AdditionalGUID && isCuttingCompleted ? removeAdditionalOperationTmpl : null,
                additionalOperation: item
              }"
              *ngFor="let item of estimate?.Operations">
            </ng-container>
          </tbody>

          <tfoot *ngIf="confirmedOrder || showItemsPriceBeforeVerified">
            <tr>
              <td i18n colspan="4">Итого</td>
              <td *ngIf="hasOperationsDiscount">
                {{ estimate?.DiscountOperation || 0 | formatNumber : 2 }}
              </td>
              <td>
                {{ estimate?.PriceOperation - estimate?.DiscountOperation || 0 | formatNumber : 2 }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </ng-container>
    <ng-template #showOnlyMainWorkBlock>
      <div class="mat-elevation-z2 flex-1">
        <mat-divider></mat-divider>
        <table class="simple" fusePerfectScrollbar>
          <thead>
            <tr>
              <th i18n>Наименование</th>
              <th i18n>Количество</th>
              <th i18n>Ед. изм.</th>
              <th i18n *ngIf="confirmedOrder || showItemsPriceBeforeVerified">Цена</th>
              <th i18n *ngIf="confirmedOrder || showItemsPriceBeforeVerified">Скидка</th>
              <th i18n *ngIf="confirmedOrder || showItemsPriceBeforeVerified">Стоимость</th>
              <th *ngIf="addedAdditionalOperations(estimate?.Operations).length > 0"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td i18n>{{ nameMainWork }}</td>
              <td>1</td>
              <td>-</td>
              <td *ngIf="confirmedOrder || showItemsPriceBeforeVerified">
                {{
                  getPriceOrderWithoutAdditionalOperations(estimate) + getProductsTotalPrice(products)
                    | formatNumber : 2
                    | formatCurrency
                }}
              </td>
              <td *ngIf="confirmedOrder || showItemsPriceBeforeVerified">
                {{
                  estimate?.DiscountOrder +
                    estimate?.DiscountMaterial +
                    estimate?.DiscountOperation -
                    getDiscountWithAdditionalOperations(estimate?.Operations) || 0
                    | formatNumber : 2
                    | formatCurrency
                }}<span class="pl-1" *ngIf="showDiscountPercent">({{ getDiscountPercentByOnlyCutting() }}%)</span>
              </td>
              <td *ngIf="confirmedOrder || showItemsPriceBeforeVerified">
                {{
                  estimate?.PriceOrderWithDiscount -
                    (getPriceAdditionalOperations(estimate?.Operations) -
                      getDiscountWithAdditionalOperations(estimate?.Operations)) || 0
                    | formatNumber : 2
                    | formatCurrency
                }}
              </td>
            </tr>
            <ng-container *ngIf="addedAdditionalOperations(estimate?.Operations).length > 0">
              <tr *ngFor="let item of addedAdditionalOperations(estimate?.Operations)">
                <td i18n>{{ item.Name }}</td>
                <td>{{ item.Count | formatNumber : countPrecision : false }}</td>
                <td>{{ item.Measure }}</td>
                <td *ngIf="confirmedOrder || showItemsPriceBeforeVerified">
                  {{ item.Price / (item.Count || 1) | formatNumber : 2 }}
                </td>
                <td *ngIf="confirmedOrder || showItemsPriceBeforeVerified">
                  {{ item.Discount | formatNumber : 2 | formatCurrency
                  }}<span *ngIf="showDiscountPercent">({{ item.DiscountPct }}%)</span>
                </td>
                <td *ngIf="confirmedOrder || showItemsPriceBeforeVerified">
                  {{ item.Price - item.Discount | formatNumber : 2 }}
                </td>
                <td class="icon-column">
                  <button
                    mat-icon-button
                    i18n-matTooltip
                    matTooltip="Удалить"
                    (click)="removeAdditionalOperation(item)">
                    <mat-icon>remove_circle_outline</mat-icon>
                  </button>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </ng-template>

    <!-- ADDITIONAL OPTIONS -->
    <div class="mat-elevation-z2 flex-1" *ngIf="estimate?.AdditionalOperations?.length && isCuttingCompleted">
      <mat-toolbar>
        <span i18n>Дополнительные услуги</span>
      </mat-toolbar>
      <mat-divider></mat-divider>
      <table class="simple" fusePerfectScrollbar>
        <thead>
          <ng-container
            *ngTemplateOutlet="
              headerTemplate;
              context: {
                hasDiscount: hasAdditionalOperationsDiscount,
                hasAdditionalOperations: true,
                showDescription: hasAdditionalOperationsDescription
              }
            ">
          </ng-container>
        </thead>
        <tbody>
          <ng-container
            [ngTemplateOutlet]="bodyRowTemplate"
            [ngTemplateOutletContext]="{
              name: getMaterialName(item.Name, item.Article),
              count: item.Count,
              measure: item.Measure,
              cost: item.Price,
              discount: item.Discount,
              discountPct: item.DiscountPct,
              hasDiscount: hasAdditionalOperationsDiscount,
              showDescription: hasAdditionalOperationsDescription,
              description: item.Description,
              additionalOperationTmpl: item.AdditionalGUID ? addAdditionalOperationTmpl : null,
              additionalOperation: item
            }"
            *ngFor="let item of estimate?.AdditionalOperations">
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <ng-template
    #headerTemplate
    let-hasDiscount="hasDiscount"
    let-hasAdditionalOperations="hasAdditionalOperations"
    let-showDescription="showDescription">
    <tr>
      <th i18n>Название</th>
      <th i18n>Количество</th>
      <th i18n>Ед. изм.</th>
      <th i18n *ngIf="confirmedOrder || showItemsPriceBeforeVerified">Цена {{ currency }}</th>
      <th i18n *ngIf="(confirmedOrder || showItemsPriceBeforeVerified) && hasDiscount">Скидка</th>
      <th i18n *ngIf="confirmedOrder || showItemsPriceBeforeVerified">Стоимость {{ currency }}</th>
      <th class="icon-column" *ngIf="showDescription"></th>
      <th class="icon-column" *ngIf="hasAdditionalOperations"></th>
    </tr>
  </ng-template>

  <ng-template
    #bodyRowTemplate
    let-name="name"
    let-count="count"
    let-measure="measure"
    let-cost="cost"
    let-discount="discount"
    let-discountPct="discountPct"
    let-hasDiscount="hasDiscount"
    let-additionalOperationTmpl="additionalOperationTmpl"
    let-additionalOperation="additionalOperation"
    let-showDescription="showDescription"
    let-description="description">
    <tr>
      <td>
        {{ name }}
      </td>
      <td>
        {{ count | formatNumber : countPrecision : false }}
      </td>
      <td>
        {{ measure }}
      </td>
      <td *ngIf="confirmedOrder || showItemsPriceBeforeVerified">
        {{ cost / (count || 1) | formatNumber : 2 }}
      </td>
      <td *ngIf="(confirmedOrder || showItemsPriceBeforeVerified) && hasDiscount && showDiscountPercent">
        {{ discount | formatNumber : 2 | formatCurrency }}
        ({{ discountPct }}%)
      </td>
      <td *ngIf="(confirmedOrder || showItemsPriceBeforeVerified) && hasDiscount && !showDiscountPercent">
        {{ discount | formatNumber : 2 | formatCurrency }}
      </td>
      <td *ngIf="confirmedOrder || showItemsPriceBeforeVerified">
        {{ cost - discount | formatNumber : 2 }}
      </td>
      <td class="icon-column" *ngIf="showDescription">
        <mat-icon *ngIf="description" [matTooltip]="description">info_outline</mat-icon>
      </td>
      <ng-container *ngTemplateOutlet="additionalOperationTmpl; context: { additionalOperation: additionalOperation }">
      </ng-container>
    </tr>
  </ng-template>

  <ng-template #addAdditionalOperationTmpl let-additionalOperation="additionalOperation">
    <td class="icon-column">
      <button mat-stroked-button i18n (click)="addAdditionalOperation(additionalOperation)">Добавить к заказу</button>
    </td>
  </ng-template>

  <ng-template #removeAdditionalOperationTmpl let-additionalOperation="additionalOperation">
    <td class="icon-column">
      <button
        mat-icon-button
        i18n-matTooltip
        matTooltip="Удалить"
        (click)="removeAdditionalOperation(additionalOperation)">
        <mat-icon>remove_circle_outline</mat-icon>
      </button>
    </td>
  </ng-template>
</div>
